import { useEffect, useState } from "react";
import networkCallWrapper, { TReq } from "../utils/networkCallWrapper";

function useNetworkRequest<T = unknown>({
  networkCallParams,
  dependencyList = [],
  dependencyCondition = true,
  forceUpdate = false,
  removePreviousData = false
}: {
  networkCallParams: TReq;
  dependencyList?: any[];
  dependencyCondition?: boolean;
  forceUpdate?: boolean;
  removePreviousData?: boolean;
}) {
  const [networkState, setNetworkState] = useState<{
    isFetching: boolean;
    isRevalidating: boolean;
    data: T | null;
    errors: unknown;
    refreshData: boolean;
  }>({
    isFetching: true,
    isRevalidating: false,
    data: null,
    errors: null,
    refreshData: false
  });

  const refresh = () => {
    setNetworkState(prev => ({
      ...prev,
      refreshData: !prev.refreshData,
      isRevalidating: true
    }));
  };

  useEffect(() => {
    const func = async () => {
      setNetworkState(prev => ({
        ...prev,
        isFetching: prev.isRevalidating ? false : true
      }));

      const request = await networkCallWrapper(networkCallParams);

      if (request?.success) {
        setNetworkState(prev => ({
          ...prev,
          data: request.data as T,
          isFetching: false,
          isRevalidating: false
        }));
      } else {
        setNetworkState(prev => ({
          ...prev,
          data: removePreviousData ? null : (prev.data as T),
          errors: request?.errors,
          isFetching: false,
          isRevalidating: false
        }));
      }
    };

    if (networkState.data && !networkState?.isRevalidating && !forceUpdate) {
      // do nothing
    } else {
      if (dependencyCondition) {
        func();
      }
    }
  }, [networkState?.refreshData, ...dependencyList, dependencyCondition]);

  return {
    refresh: refresh,
    errors: networkState.errors,
    isFetching: networkState.isFetching,
    data: networkState.data,
    isRevalidating: networkState.isRevalidating
  };
}

export default useNetworkRequest;
